<script>
  export default {
    methods: {
      titleize(st){
        if (st) {
          console.log(st)
          let lblPart = st.split('|').slice(-1)[0]
          console.log(lblPart)

          let words = lblPart.replace('_',' ').split(' ')
          let newWords = words.map(word => {
            return word.charAt(0).toUpperCase() + word.slice(1)
          })
          return newWords.join(' ')
        } else {
          return null
        }
      },
      symbolize(st) {
        return st ? st.toLowerCase().replace(' ', '_') : null
      },
      reorder(arr, order){
        return order.map(i => arr[i]);
      }
    }
  }
</script>